import {
  launchExperienceType,
  trackEventType,
  userPropertiesType,
  submitFormType,
  removeSubmitFormAction,
  addSubmitFormAction,
  continueType,
  requestReviewType,
} from 'lib/actions';

// In order to work better for the SDK
// we put the launch-experience action to the last position
const sortActions = actions =>
  actions?.sort((a, b) => {
    if (a.type === launchExperienceType) return 1;
    if (b.type === launchExperienceType) return -1;
    return 0;
  });

/*
 * Group the actions by their type
 * @param {array} actions - Actions array containing all the set actions
 * @returns {object} Actions grouped by their type
 */
export function groupedActions(actions) {
  const actionsMapped = {
    actions: [],
    events: [],
    userProperties: [],
    submitForm: [],
  };

  actions.forEach(action => {
    if (action.type === trackEventType) {
      actionsMapped.events.push(action);
    }
    if (action.type === userPropertiesType) {
      actionsMapped.userProperties.push(action);
    }
    if (action.type === submitFormType) {
      actionsMapped.submitForm.push(action);
    }
    if (
      action.type !== trackEventType &&
      action.type !== userPropertiesType &&
      action.type !== submitFormType
    ) {
      actionsMapped.actions.push(action);
    }
  });

  return actionsMapped;
}

function actionsMapper({ prevActions, newActions, hasSurveyBlock = false }) {
  const continuePrevAction = prevActions.find(
    ({ type }) => type === continueType
  );

  const unrelatedActionsToSurvey = new Set([requestReviewType]);

  const actionsChanged = newActions?.actions
    ?.filter(({ type }) => !unrelatedActionsToSurvey.has(type))
    .some(({ type, config }) =>
      type === continueType && continuePrevAction
        ? continuePrevAction.config !== config
        : !prevActions.map(prevAction => prevAction.type).includes(type)
    );

  const handleSubmitForm = hasSurveyBlock && actionsChanged;

  // We need to map submit form action only if the step has survey block
  const updatedNewActions = handleSubmitForm
    ? addSubmitFormAction(newActions)
    : newActions;

  const updatedPrevActions = handleSubmitForm
    ? removeSubmitFormAction({ actions: prevActions }).actions
    : prevActions;

  // We need to map the actions to their category (actions, events, userProperties, submitForm)
  // so we can determine if we need to overwrite or append
  const prevActionsMapped = groupedActions(updatedPrevActions);

  // Then we just merge the objects together
  // and it overwrites the previous actions when the new action is the same category
  const updated = {
    ...prevActionsMapped,
    ...updatedNewActions,
  };

  // Then we flat all the actions in a single array of objects
  const allActions = [
    ...updated.submitForm,
    ...sortActions(updated.actions),
    ...updated.events,
    ...updated.userProperties,
  ];

  // Then we remove duplicates
  return allActions.filter(
    (action, index) =>
      allActions.findIndex(a => a.type === action.type) === index
  );
}

export default actionsMapper;
